module.exports = __webpack_public_path__ + "static/img/clothing_11.1437cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_11.png
// module id = A4lm
// module chunks = 0